import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Mexican RFC validator following Single Responsibility Principle
 */
export class RfcValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Mexican RFC',
      pattern: /^[A-Z&Ñ]{3,4}\d{6}[A-Z\d]{3}$/i,
      minLength: 12,
      maxLength: 13
    });
  }

  validateFormat(id) {
    const upperCaseId = id.toUpperCase();
    
    // Check length
    if (upperCaseId.length < this.config.minLength || upperCaseId.length > this.config.maxLength) {
      return ValidationResult.invalid('RFC length must be 12 or 13 characters');
    }

    // Check pattern
    return this.validateRegex(
      upperCaseId,
      this.config.pattern,
      'RFC format must be 3-4 letters, 6 digits, and 3 alphanumeric characters'
    );
  }

  validateChecksum(id) {
    // RFC validation is primarily format-based
    // The last 3 characters include a check digit but the algorithm is complex
    return ValidationResult.valid('Valid RFC format');
  }
}